import { Component, Input } from '@angular/core';

@Component({
  selector: 'nx-ng-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  @Input()
  label = '';
}
